module.exports = __webpack_public_path__ + "img/sierra-leone.81168561.png";